import { useState } from "react";
import { CustomerFormInfo, VehicleFormInfo } from "../types/form";
import {
  formInitialValues,
  vehicleInitialValues,
} from "../types/formConstants";

const useFormContext = () => {
  const [customerId, setCustomerId] = useState("");
  const [customerData, setCustomerData] =
    useState<CustomerFormInfo>(formInitialValues);
  const [vehicleData, setVehicleData] =
    useState<VehicleFormInfo>(vehicleInitialValues);
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [amis, setAmis] = useState<string>("");
  const [viewedPlans, setViewedPlans] = useState<boolean>(false);
  const [vehicles, setVehicles] = useState<any[]>([]);
  const [rate, setRate] = useState<number>(0);

  const nextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const resetContext = () => {
    setCustomerId("");
    setCustomerData(formInitialValues);
    setVehicleData(vehicleInitialValues);
    setCurrentStep(0);
    setAmis("");
    setViewedPlans(false);
    setVehicles([]);
  };

  return {
    setCustomerData,
    setVehicleData,
    setCurrentStep,
    setViewedPlans,
    setCustomerId,
    customerData,
    resetContext,
    setVehicles,
    vehicleData,
    viewedPlans,
    currentStep,
    customerId,
    vehicles,
    nextStep,
    prevStep,
    setAmis,
    setRate,
    amis,
    rate,
  };
};

export default useFormContext;
